export class Position {
  permissionGroup: string = "";
  permissionGroupWhenActivelyAssigned: string = "";
  description: string = '';
  name: string = '';
  title: string = '';
  state: number = 0;
  id: string = '00000000-0000-0000-0000-000000000000';
  timeString: Date = new Date();
  shouldAlwaysBeAssigned: boolean = false;
  allowMultipleActiveAssigns: boolean = false;
  isDisabledAdminPosition?: boolean = false;
}
